@if (($safeNavigationMigration(dynRemote?.isLoggedIn$) | async)) {
    <div class="filter-panel">
        <text-search-input
            class="filter-panel_item -asset-symbol"
            [searchFilter]="$any(widgetFilter.filters.assetSymbol)"
            (filterChange)="widgetFilter.onChange()">
        </text-search-input>

        <!-- It's not supported/not needed -->
        <!--<checkbox-search-input
            class="filter-panel_item -only-supported"
            [searchFilter]="$any(widgetFilter.filters.isOnlySupportedAssets)"
            (filterChange)="widgetFilter.onChange()">
        </checkbox-search-input>-->

        <button refreshButton
                class="filter-panel_item"
                (click)="refresh$.next()">
        </button>

        <button
            class="filter-panel_item -transfer-button"
            (click)="onTransfer()">
            <svg><use xlink:href="#swap"></use></svg>
            Transfer
        </button>
    </div>
}
<partial-loading-indicator class="dex-dyn-w_loading-indicator" #loadingIndicator [isLoading]="staticIsLoading">

    <dyn-auth-widget-body
        title="No assets avaialble">
    </dyn-auth-widget-body>

    @if (dynRemote?.isLoggedIn$.value === true) {
        <dyn-single-wallet-balances
            [filters]="widgetImpl.settings.filters"
            [refresh$]="refresh$">
        </dyn-single-wallet-balances>
    }

</partial-loading-indicator>
